import React, { useState } from 'react'
import { SampleImageBoxPagination } from '../../../../component/imageDetail/imageBoxPagination'
import MainImage from '../../imageDetail/mainImage'
import { ImageDetailContext } from '../content'
import OtherOperation from '../../imageDetail/operationView/actionGroup'
import { IMAGE_DETAIL_TAB } from '../infoView'
import styles from './index.module.less'

export type OperationViewProps = {
    imgInfoList: Array<any>
    setImgInfoList:any,
    setInnerIndex: React.Dispatch<React.SetStateAction<number>>,
    innerIndex:any,
    onInit:()=>void,
    currentImage:any,
    setBanOperation:(arg:boolean)=>void,
    onOuterChange:(arg: number)=>void,
    maxListLength:number,
    currentIndexInList:number,
    tabValue: IMAGE_DETAIL_TAB,
    isAnnotate:boolean,
    setIsAnnotate:any,
}

export default ({
  innerIndex,
  imgInfoList,
  setImgInfoList,
  setInnerIndex,
  onInit,
  currentImage,
  setBanOperation,
  onOuterChange,
  maxListLength,
  currentIndexInList,
  tabValue,
  isAnnotate,
  setIsAnnotate,
}:OperationViewProps) => {
  const [showNoteLabel, setShowNoteLabel] = useState(true)
  const [scale, setScale] = useState(null)

  const onShowNoteLabel = (val) => {
    setShowNoteLabel(val)
  }

  return <div className={styles.mnImageDetailOperationView}>
    <div className={styles['img-actions']}>
      <div className={styles['action-pagination']}>
        <SampleImageBoxPagination
          currentImage={currentImage}
          imgInfoList={imgInfoList}
          setImgInfoList={setImgInfoList}
          setInnerIndex={setInnerIndex}
          init={onInit}
        />
      </div>
      <MainImage
        content={ImageDetailContext}
        innerIndex={innerIndex}
        setInnerIndex={setInnerIndex}
        imgInfoList={imgInfoList}
        scale={scale}
        setScale={setScale}
        maxListLength={maxListLength}
        currentImage={currentImage}
        setBanOperation={setBanOperation}
        onOuterChange={onOuterChange}
        currentIndexInList={currentIndexInList}
        showNoteLabel={showNoteLabel}
        showBox={false}
      />
    </div>
    <OtherOperation
      scale={scale}
      setScale={setScale}
      tabValue={tabValue}
      currentImage={currentImage}
      imgInfoList={imgInfoList}
      isSampleDetail
      sampleData={currentImage}
      showBox={undefined}
      onShowBox={undefined}
      isAnnotate={isAnnotate}
      setIsAnnotate={setIsAnnotate}
      showNoteLabel={showNoteLabel}
      onShowNoteLabel={onShowNoteLabel}
    />
  </div>
}
